import React from 'react'
import {
  Box,
  Text,
  Select,
} from '@usap/uicomponents'
import SetKitDisplay from '../../../../../SetKitDisplay'
import ReturnStatus from '../../../../../ReturnStatus'
import PartNo from './PartNo'
import QuantitySelection from './QuatitySelection'
import UnitPrice from './UnitPrice'
import TotalPrice from './TotalPrice'
import { disableStyle } from '../../constant'
import { setQtyRange } from '../../utils'
import { Container, BrandText } from "../../../style/ReturnItemDetailWMO.css"
import QuantitySelectionWMO from './QuantitySelectionWMO'
import ReturnStatusWMO from '../../../../../ReturnStatusWMO'
import UnitPriceWMO from './UnitPriceWMO'

const ReturnItemDetailWMO = props => {
  const {
    isDesktop,
    orderItems,
    eligibleRMA,
    brandText,
    selectedPart,
    partNumber,
    showTabs,
    ikey,
    qtyRange,
    qtyToCompute,
    handleQtyChange,
    itemPriceParsed,
    selectedQty,
    imageText,
    itemTotal,
    parentSku,
    etaToShow,
    returnStatusData,
    orderInfo,
    Link,
    creditStatus,
    returnRequestStatus,
    setReturnDetailsData,
    setDisplayReturnDetails,
    showCheckBox,
    multipleItemsPresent,
    itemEligibleForReturnWindow,
  } = { ...props }

  const itemWidth = showCheckBox && isDesktop ? '60%' : '100%'

  return (
    <Container>
      <Box style={eligibleRMA ? null : disableStyle} direction="row" align='center'>
        <Box direction="column" align='flex-start' style={multipleItemsPresent ? { flex: 1 } : { width: itemWidth }}>
          <BrandText isDesktop={isDesktop} style={multipleItemsPresent ? { maxWidth: '500px', width: '100%' } : null}>
            <Text
              color="dark-2"
              dangerouslySetInnerHTML={{ __html: brandText }}
            />
            {' '}
            <Text
              color="dark-2"
              dangerouslySetInnerHTML={{ __html: imageText }}
            />
          </BrandText>
          <PartNo partNumber={partNumber} isWmoEnabled />
          {!showTabs && !isDesktop && (
            <>
              <Box width={multipleItemsPresent ? '120px' : '100%'} margin={multipleItemsPresent ? { vertical: '8px' } : null}>
                <QuantitySelectionWMO
                  eligibleRMA={eligibleRMA && itemEligibleForReturnWindow}
                  partNumber={partNumber}
                  setQtyRange={setQtyRange}
                  handleQtyChange={handleQtyChange}
                  ikey={ikey}
                  qtyRange={qtyRange}
                  qtyToCompute={qtyToCompute}
                  multipleItemsPresent={multipleItemsPresent}
                />
              </Box>
            </>
          )}
          {<UnitPriceWMO itemPriceParsed={itemPriceParsed} multipleItemsPresent={multipleItemsPresent} />}
          {<TotalPrice
            itemTotal={itemTotal}
            type="noSelectedPartAndNotDesktop"
            showTabs={showTabs}
            selectedPart={selectedPart}
            isDesktop={isDesktop}
            multipleItemsPresent={multipleItemsPresent}
            isWmoEnabled
          />}
          {<TotalPrice
            itemTotal={itemTotal}
            type="showTabAndSelectedPart"
            showTabs={showTabs}
            selectedPart={selectedPart}
            isDesktop={isDesktop}
            multipleItemsPresent={multipleItemsPresent}
            isWmoEnabled
          />}
          {isDesktop && !showTabs && parentSku && (
            <SetKitDisplay
              parentSku={parentSku}
              showPartNumber={false}
              isWmoEnabled
              multipleItemsPresent={multipleItemsPresent}
            />
          )}
        </Box>
        {isDesktop && !showTabs && (
          <>
            <Box width={multipleItemsPresent ? '120px' : '100%'}>
              <QuantitySelectionWMO
                eligibleRMA={eligibleRMA && itemEligibleForReturnWindow}
                partNumber={partNumber}
                setQtyRange={setQtyRange}
                handleQtyChange={handleQtyChange}
                ikey={ikey}
                qtyRange={qtyRange}
                qtyToCompute={qtyToCompute}
                multipleItemsPresent={multipleItemsPresent}
              />
            </Box>
            <Box style={{ width: '20%' }}>
              <Text
                size={multipleItemsPresent ? '20px' : 'small'}
                color="placeholder"
                style={{ fontWeight: multipleItemsPresent ? 600 : 400, marginTop: 5, marginBottom: 5, textAlign: 'right' }}
              >
                $
                {(itemPriceParsed * selectedQty).toFixed(2)}
              </Text>
            </Box>
          </>
        )}
      </Box>
      {isDesktop && etaToShow}
      {isDesktop && returnStatusData && (
        <ReturnStatusWMO
          returnStatusData={returnStatusData}
          orderDetails={orderInfo}
          Link={Link}
          creditStatus={creditStatus}
          returnRequestStatus={returnRequestStatus}
          setReturnDetailsData={setReturnDetailsData}
          setDisplayReturnDetails={setDisplayReturnDetails}
          isDesktop={isDesktop}
        />
      )}
    </Container>
  )
}

export default ReturnItemDetailWMO
